@if (embedded()) {
	@if (rolePermissions.canViewPanelDeveloperCurl()) {
		<div class="top-nationalities-embedded__actions">
			<tec-button-icon
				icon="icon-code-brackets"
				type="default"
				size="sm"
				(clickEvent)="openCurlModal()"
			/>
		</div>
	}
	<tec-table [rows]="content" [config]="config" />
} @else {
	<tec-tile [title]="'PANEL.TOP_NATIONALITIES' | translate">
		@if (rolePermissions.canViewPanelDeveloperCurl()) {
			<ng-container actions>
				<tec-button-icon
					icon="icon-code-brackets"
					type="default"
					size="sm"
					(clickEvent)="openCurlModal()"
				/>
			</ng-container>
		}
		<tec-table [rows]="content" [config]="config" />
	</tec-tile>
}

@if (curlModalOpen()) {
	<app-modal-curl-request
		[titleKey]="'PANEL.CURL_MODAL.TITLE_TOP_NATIONALITIES'"
		[curlText]="getTopNationalityCurl()"
		(closeEvent)="closeCurlModal()"
	/>
}
